import React from 'react';
import { ShieldCheck } from 'lucide-react';

// Network-verification confidence: distinct-patient confirmations vs the
// practice threshold. Unlike the model-confidence meter, this is a count/target
// ratio — at/above threshold the plan is trusted and stops routing for calls.
export default function NetworkConfidence({ count = 0, threshold = 10, level = 'low' }) {
  const ratio = threshold ? Math.min(1, count / threshold) : 0;
  const tone = level === 'high'
    ? { bar: 'bg-emerald-500', text: 'text-emerald-700' }
    : { bar: 'bg-amber-500', text: 'text-amber-700' };
  return (
    <span className="inline-flex items-center gap-1.5" title={`${count} of ${threshold} confirmed cases — the plan is trusted (and stops routing for calls) at ${threshold}`}>
      <span className="h-1.5 w-12 rounded-full bg-slate-200 overflow-hidden">
        <span className={`block h-full rounded-full ${tone.bar}`} style={{ width: `${ratio * 100}%` }} />
      </span>
      <span className={`text-[11px] font-semibold tnum ${tone.text}`}>{count}/{threshold}</span>
      {level === 'high' && (
        <span className="inline-flex items-center gap-0.5 text-[10px] font-medium text-emerald-700">
          <ShieldCheck className="h-3 w-3" />High
        </span>
      )}
    </span>
  );
}
